import CoursesGrid from "./courses-grid";
import { useCoursesData } from "~/routes/courses/layout";


function Courses() {
    const { courses } = useCoursesData();
    if (!courses || courses.length === 0) {
        throw new Response("No courses found", {
            status: 404,
            statusText: "No courses found",
            headers: { "Content-Type": "text/plain" }
        });
    }
    return (<CoursesGrid courses={courses} />);
}

export default function CoursesSection() {

    return (
        <>
            <section id="courses" className="courses">
                <div className="container" data-aos="fade-up">
                    <div className="row" data-aos="zoom-in" data-aos-delay="100">
                        <Courses />
                    </div>
                </div>
            </section>
        </>
    );
}